import React, {Component} from 'react';
import {Dialog, ValidatingInput} from '../widgets/';
import {connect} from 'react-redux';
import {uiActions} from '../chrome';
import actions from './profile.actions';

import './InviteDialog.css';
import Icon from '../widgets/Icon';
import FancyButton from '../widgets/FancyButton';
import {getShareB2MeFacebook, getShareB2MeLinkedin} from './sharing.util';

// Kudos; http://emailregex.com/
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const EMAIL_FIELD_COUNT = 8;

class InviteDialog extends Component {
	constructor() {
		super();

		this.state = {
			emails: ['', '', '', '', '', '']
		};

		this.changeEmail = (e, idx) =>
			this.setState({
				emails: this.state.emails.map((email, iidx) => (idx === iidx ? e.target.value : email))
			});
		this.changeMessage = e => this.setState({message: e.target.value});
		this.send = () => this.props.onSend(this.state.emails.filter(email => !!email));
	}

	render() {
		const {onCancel} = this.props;
		const {emails} = this.state;

		const emailsValidity = emails.map(email => EMAIL_REGEX.test(email));
		const hasAnyValidEmail = emailsValidity.reduce((accum, validity) => accum || validity, false);

		return (
			<Dialog
				buttons={['send', 'cancel']}
				onSend={this.send}
				onCancel={onCancel}
				emphasis="send"
				disabled={{send: !hasAnyValidEmail}}
				title="Invite someone to B2Me">
				<ul className="InviteDialog">
					<li>
						<FancyButton className="emphasis" onClick={getShareB2MeFacebook}>
							<Icon name="facebook2" />
							Invite via Facebook
						</FancyButton>
						<FancyButton className="emphasis" onClick={getShareB2MeLinkedin}>
							<Icon name="linkedin" />
							Invite via LinkedIn
						</FancyButton>
					</li>
					<li>
						<label>Or, enter up to {emails.length} email addresses:</label>
					</li>
					{emails.map((email, idx) => (
						<li key={idx}>
							<ValidatingInput
								className="InviteDialog-email"
								type="text"
								placeholder="e.g. fred@b2me.com.au"
								value={email}
								onChange={e => this.changeEmail(e, idx)}
								isValid={emails[idx] && emailsValidity[idx]}
								invalidMessage="Required"
								invalidTitle="An email address is required"
								validIcon=""
							/>
						</li>
					))}
					<li>
						<em>
							<Icon name="warning" />
							Initial emails from B2Me can be flagged as junk by email service providers, please
							follow-up with the recipient if necessary
						</em>
					</li>
				</ul>
			</Dialog>
		);
	}
}

const ConnectedInviteDialog = connect(
	state => ({}),
	dispatch => ({
		onSend: emails => {
			dispatch(actions.invite(emails));
			dispatch(uiActions.uiModal(null));
		},
		onCancel: () => {
			dispatch(uiActions.uiModal(null));
		}
	})
)(InviteDialog);

export default ConnectedInviteDialog;



// WEBPACK FOOTER //
// ./src/profile/InviteDialog.js